import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {useChangeLogAccordionStore, useVipLocalStore, VipLocalStore} from '@modules'
import {ChangeLogAccordionStore} from '@modules/changelog/ChangeLogAccordion'
import {StoresInstance} from '@stores'
import { ChangeLogEntriesByItemByTimestamp } from '.'
import * as css from './GroupedChangeLogItemsForAccordion.css'

/// region Store

export class GroupedChangeLogItemsForAccordionStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'> & {accordion: ChangeLogAccordionStore}) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  get items() {
    return this.props.accordion.changeEvents
  }

  @computed get itemsInTimestampOrder() {
    return _.orderBy(this.items, i => i._log.timestamp, 'desc')
  }

  @computed get timestampsInDescOrder() {
    return _.uniq(this.itemsInTimestampOrder.map(i => i._log.timestamp))
  }

  @computed get itemsByTimestamp() {
    return _.groupBy(this.items, item => item._log.timestamp)
  }
}

export const GroupedChangeLogItemsForAccordionStoreContext = React.createContext<GroupedChangeLogItemsForAccordionStore>(null)
export const useGroupedChangeLogItemsForAccordionStore = () => React.useContext(GroupedChangeLogItemsForAccordionStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const GroupedChangeLogItemsForAccordion = observer<MyProps>(function GroupedChangeLogItemsForAccordion({className, ...props}) {
  const accordion = useChangeLogAccordionStore(),
    obsProps = useAsObservableSource({...props, accordion}),
    store = useVipLocalStore((stores) => new GroupedChangeLogItemsForAccordionStore(stores, obsProps)),
    {itemsByTimestamp, timestampsInDescOrder, props: {accordion: {toggleExpanded}}} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <GroupedChangeLogItemsForAccordionStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)} onDoubleClick={toggleExpanded}>
        {timestampsInDescOrder.map(time => <ChangeLogEntriesByItemByTimestamp key={time} items={itemsByTimestamp[time] ?? []} timestamp={time} />)}
      </div>
    </GroupedChangeLogItemsForAccordionStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/changelog/entries/GroupedChangeLogItemsForAccordion.tsx